import React, { useState, useEffect } from 'react';
import FiltrosTabla from './FiltrosTabla';
import TablaComponente from './TablaComponente';
import Paginacion from './Paginacion'; // Un nuevo componente para los controles de paginación

const TablaTramitacionExternaContainer = () => {
    // Estados para los datos y la carga
    const [datosOriginales, setDatosOriginales] = useState([]);
    console.log("DATAx ORIGINALES (desde el fetch) (1) --->", datosOriginales)
    const [datosFiltrados, setDatosFiltrados] = useState([]);
    console.log("CUANTOS DATOS FILTRADOS --->", datosFiltrados)
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    // Estados para los filtros
    const [filters, setFilters] = useState({
        area_responsable: '',
        nombre_obra: '',
        expediente: '',
        objeto: '',
        etapa_expediente: '',
        search: ''
    });
    console.log("FILTERS --->", filters)

    const [datosAplanados, setDatosAplanados] = useState([]); // Nuevo estado para los datos aplanados
    console.log("DATOS APLANADOS --->", datosAplanados)
    // Estados para la paginación
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // Nuevo estado

    // useEffect para obtener los datos de la API (solo en la carga inicial)
    useEffect(() => {
        const fetchDatos = async () => {
            try {
                const response = await fetch('/api/tabla_tramitacion_externa');
                if (!response.ok) {
                    throw new Error('Error al obtener los datos de la API');
                }
                const data = await response.json();
                setDatosOriginales(data);
                setDatosFiltrados(data); // Inicialmente, los datos filtrados son los mismos
            } catch (err) {
                setError(err.message);
            } finally {
                setIsLoading(false);
            }
        };

        fetchDatos();
    }, []);

    // useEffect para aplicar filtros (cada vez que un filtro cambia) //#FILTER-A
    /*useEffect(() => {
        const aplicarFiltros = () => {
            let tempDatos = [...datosOriginales];

            // Lógica de filtrado por nombre de obra
            if (filtroNombreObra) {
                tempDatos = tempDatos.filter(item =>
                    item.nombre_obra && item.nombre_obra.includes(filtroNombreObra)
                );
            }

            // Lógica de filtrado por expediente (con la validación segura)
            if (filtroExpediente) {
                tempDatos = tempDatos.flatMap(item => {
                    if (item.tramitacion_externa_jsonb) {
                        return item.tramitacion_externa_jsonb.filter(tramite =>
                            tramite.exp && tramite.exp.includes(filtroExpediente)
                        ).map(tramite => ({ ...item, tramitacion_externa_jsonb: [tramite] }));
                    }
                    return [];
                });
            }

            setDatosFiltrados(tempDatos);
            setCurrentPage(1); // Resetear a la primera página
        };

        aplicarFiltros();
    }, [filtroNombreObra, filtroExpediente, datosOriginales]);*/

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const limpiarFiltros = () => {
        setFilters({
            area_responsable: '',
            nombre_obra: '',
            expediente: '',
            objeto: '',
            etapa_expediente: '',
            search: ''
        });
    };

    //FILTROS_TEST
    useEffect(() => {
        const aplicarFiltros = () => {
            let tempDatos = [...datosOriginales];
            console.log(tempDatos)

            //Logica de filtrado por etapa
            {/*
                const value_estado_exp = 
                (item.fecha_firma_reso !== undefined && item.fecha_firma_reso !== null) ? 100 : //null or undefined
                (item.fecha_salida_reso !== undefined && item.fecha_salida_reso !== null) ? 75 :
                (item.fecha_firma_convenio !== undefined && item.fecha_firma_convenio !== null) ? 50 : 25;
            */}
            {/*
                ORDEN DE LAS ETAPAS:
                25% - fecha_salida_convenio
                50% - fecha_firma_convenio
                75% - fecha_salida_reso
                100% - fecha_firma_reso
                
                ETAPAS:
                25%: filtrar solo los que tengan item.fecha_salida_convenio !== undefined y item.fecha_salida_convenio !== null
                pero que la fecha_firma_reso sea undefined o null

                50%: filtrar solo los que tengan item.fecha_firma_convenio !== undefined y item.fecha_firma_convenio !== null
                pero que la fecha_salida_reso sea undefined o null

                75%: filtrar solo los que tengan item.fecha_salida_reso !== undefined y item.fecha_salida_reso !== null
                pero que la fecha_firma_reso sea undefined o null
                
                100%: filtrar solo los que tengan item.fecha_firma_reso !== undefined y item.fecha_firma_reso !== null                         
                
                
            */}

            {/*
            if (filters.etapa_expediente) {
                tempDatos = tempDatos.flatMap(item => {                    
                    
                    if (filters.etapa_expediente === '100') {
                        return item.tramitacion_externa_jsonb.filter(tramite =>
                            tramite.fecha_firma_reso && tramite.fecha_firma_reso !== null
                        ).map(tramite => ({ ...item, tramitacion_externa_jsonb: [tramite] }));
                    }
                    if (filters.etapa_expediente === '75') {
                        return item.tramitacion_externa_jsonb.filter(tramite =>
                            (tramite.fecha_salida_reso && tramite.fecha_salida_reso !== null) &&
                            (tramite.fecha_firma_reso === undefined || tramite.fecha_firma_reso === null)
                        ).map(tramite => ({ ...item, tramitacion_externa_jsonb: [tramite] }));
                    }
                    if (filters.etapa_expediente === '50') {
                        return item.tramitacion_externa_jsonb.filter(tramite =>
                            (tramite.fecha_firma_convenio && tramite.fecha_firma_convenio !== null) &&
                            (tramite.fecha_salida_reso === undefined || tramite.fecha_salida_reso === null)
                        ).map(tramite => ({ ...item, tramitacion_externa_jsonb: [tramite] }));
                    }
                    if (filters.etapa_expediente === '25') {
                        return item.tramitacion_externa_jsonb.filter(tramite =>
                            (tramite.fecha_salida_convenio && tramite.fecha_salida_convenio !== null) &&
                            (tramite.fecha_firma_convenio === undefined || tramite.fecha_firma_convenio === null)
                        ).map(tramite => ({ ...item, tramitacion_externa_jsonb: [tramite] }));
                    }
                });
            }
            */}
            // Mapeo de etapas a sus respectivas condiciones de filtro
            const etapasFiltro = {
                '25': tramite =>
                    (tramite.fecha_salida_convenio && tramite.fecha_salida_convenio !== null) &&
                    (tramite.fecha_firma_convenio === undefined || tramite.fecha_firma_convenio === null),

                '50': tramite =>
                    (tramite.fecha_firma_convenio && tramite.fecha_firma_convenio !== null) &&
                    (tramite.fecha_salida_reso === undefined || tramite.fecha_salida_reso === null),

                '75': tramite =>
                    (tramite.fecha_salida_reso && tramite.fecha_salida_reso !== null) &&
                    (tramite.fecha_firma_reso === undefined || tramite.fecha_firma_reso === null),

                '100': tramite =>
                    tramite.fecha_firma_reso && tramite.firma_fecha_reso !== null
            };

            // Aplicar filtro por etapa si existe
            if (filters.etapa_expediente && etapasFiltro[filters.etapa_expediente]) {
                const filtroEtapa = etapasFiltro[filters.etapa_expediente];
                tempDatos = tempDatos.flatMap(item =>
                    item.tramitacion_externa_jsonb
                        .filter(filtroEtapa)
                        .map(tramite => ({
                            ...item,
                            tramitacion_externa_jsonb: [tramite]
                        }))
                );
            }

            //Logica de filtrado por area responsable
            if (filters.area_responsable) {
                tempDatos = tempDatos.filter(item =>
                    item.area_responsable && item.area_responsable.includes(filters.area_responsable)
                );
            }

            // Lógica de filtrado por nombre de obra
            if (filters.nombre_obra) {
                tempDatos = tempDatos.filter(item =>
                    item.nombre_obra && item.nombre_obra.includes(filters.nombre_obra)
                );
            }

            // Lógica de filtrado por expediente (con la validación segura)
            if (filters.expediente) {
                tempDatos = tempDatos.flatMap(item => {
                    if (item.tramitacion_externa_jsonb) {
                        return item.tramitacion_externa_jsonb.filter(tramite =>
                            tramite.exp && tramite.exp.includes(filters.expediente)
                        ).map(tramite => ({ ...item, tramitacion_externa_jsonb: [tramite] }));
                    }
                    return [];
                });
            }

            if (filters.objeto) {
                tempDatos = tempDatos.flatMap(item => {
                    if (item.tramitacion_externa_jsonb) {
                        return item.tramitacion_externa_jsonb.filter(tramite =>
                            tramite.objeto && tramite.objeto.includes(filters.objeto)
                        ).map(tramite => ({ ...item, tramitacion_externa_jsonb: [tramite] }));
                    }
                    return [];
                });
            }

            if (filters.search) {
                tempDatos = tempDatos.filter(item => {
                    // 1. Verificar si el nombre de la obra coincide
                    const nombreObraMatch = item.nombre_obra && item.nombre_obra.toLowerCase().includes(filters.search.toLowerCase());
            
                    // 2. Verificar si algún expediente coincide
                    const expedienteMatch = item.tramitacion_externa_jsonb && item.tramitacion_externa_jsonb.some(t =>
                        t.exp && t.exp.toLowerCase().includes(filters.search.toLowerCase())
                    );
                    
                    // El item pasa el filtro si coincide el nombre O si algún expediente coincide
                    return nombreObraMatch || expedienteMatch;
                }).map(item => {
                    // Si el nombre de la obra coincide (y no los expedientes), no filtramos los expedientes
                    if (item.nombre_obra && item.nombre_obra.toLowerCase().includes(filters.search.toLowerCase())) {
                        return item; // Retornamos el item sin modificar
                    }
                    
                    // Si el nombre no coincide, pero los expedientes sí, filtramos solo los expedientes que coinciden
                    if (item.tramitacion_externa_jsonb) {
                        return {
                            ...item,
                            tramitacion_externa_jsonb: item.tramitacion_externa_jsonb.filter(t =>
                                t.exp && t.exp.toLowerCase().includes(filters.search.toLowerCase())
                            )
                        };
                    }
                    
                    return item; // Retornamos el item sin modificar si no hay expedientes
                });
            }  
            

            setDatosFiltrados(tempDatos);
            setCurrentPage(1); // Resetear a la primera página
        };

        aplicarFiltros();
    }, [filters, datosOriginales]);

    // **NUEVO useEffect** para aplanar los datos cuando cambian los datos filtrados
    useEffect(() => {
        
        /*const flattenedData = datosFiltrados.flatMap(item => {
            if (item && item.tramitacion_externa_jsonb && Array.isArray(item.tramitacion_externa_jsonb)) {
                return item.tramitacion_externa_jsonb.map(tramite => ({
                    ...tramite, // Copiamos el expediente
                    nombre_obra: item.nombre_obra, // Agregamos el nombre de la obra
                    observaciones_externas: item.observaciones_externas // Agregamos las observaciones
                }));
            }
            return [];
        });
        setDatosAplanados(flattenedData);*/

        const flattenedData = datosFiltrados.flatMap(item => {
            // Validación principal para evitar errores si el item es nulo
            /*if (!item) {
                return [];
            }

            // Caso 1: Si hay tramitacion_externa_jsonb y es un array
            if (item.tramitacion_externa_jsonb && Array.isArray(item.tramitacion_externa_jsonb) && item.tramitacion_externa_jsonb.length > 0) {
                return item.tramitacion_externa_jsonb.map(tramite => ({
                    ...tramite,
                    nombre_obra: item.nombre_obra,
                    observaciones_externas: item.observaciones_externas
                }));
            } 
            
            // Caso 2: Si no hay tramitacion_externa_jsonb o el array está vacío
            else {
                // Devolvemos un objeto con los datos de la obra y los campos del trámite en null o N/A
                return [{
                nombre_obra: item.nombre_obra,
                observaciones_externas: item.observaciones_externas,
                exp: null,
                fecha_firma_reso: null,
                fecha_salida_reso: null,
                fecha_firma_convenio: null,
                fecha_salida_convenio: null,
                // Agregamos una propiedad para identificar si es un registro sin trámites
                hasNoTramite: true,
                // Para la clave, puedes usar el ID de la obra
                id: item.id || item.cg_01_id_partido_obra 
            }];
        }
        */
        // Validación principal para evitar errores si el item es nulo
        if (!item || !item.tramitacion_externa_jsonb || !Array.isArray(item.tramitacion_externa_jsonb)) {
            // Si el item o su propiedad de trámites no son válidos,
            // devolvemos un array vacío para que flatMap los ignore.
            return [];
        }

        // Filtramos y mapeamos solo los trámites que tienen un expediente no vacío
        const validTramites = item.tramitacion_externa_jsonb.filter(tramite => 
            // La condición clave: solo si el expediente existe y no es una cadena vacía
            tramite.exp
        );

        // Si hay trámites válidos, los aplanamos
        if (validTramites.length > 0) {
            return validTramites.map(tramite => ({
                ...tramite,
                nombre_obra: item.nombre_obra,
                observaciones_externas: item.observaciones_externas
            }));
        } 
        
        // Si no hay trámites válidos (expedientes con valor),
        // devolvemos un array vacío para no mostrar ninguna fila.
        return [];       
    });
    setDatosAplanados(flattenedData);
    }, [datosFiltrados]);

    // Lógica para la paginación
    const totalItems = datosAplanados.length;//datosFiltrados.length;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = datosAplanados.slice(indexOfFirstItem, indexOfLastItem);//datosFiltrados.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    // Si está cargando o hay un error, lo mostramos aquí
    if (isLoading) {
        return <div>Cargando datos...</div>;
    }
    if (error) {
        return <div>Error: {error}</div>;
    }

    // Extraer valores únicos para los selects (se hace aquí, en el padre)
    const nombresObras = [...new Set(datosOriginales.map(item => item.nombre_obra))].filter(Boolean);
    const expedientes = [...new Set(
        datosOriginales.flatMap(item => {
            if (item.tramitacion_externa_jsonb) {
                return item.tramitacion_externa_jsonb.map(tramite => tramite.exp);
            }
            return [];
        })
    )].filter(Boolean);

    // El padre renderiza a sus hijos y les pasa los datos y funciones necesarios
    return (
        <div className="w-full p-4">
            <h2 className="text-2xl font-bold mb-4">Tramitación Externa</h2>            
            
            <FiltrosTabla
                filters={filters}
                setFilters={setFilters}
                data={datosAplanados} //currentItems //Pasar todos los datos aplanados. Se usa solo para generar valores unicos en los selects
                handleFilterChange={handleFilterChange}
                limpiarFiltros={limpiarFiltros}              
            />
            {/* le pasa a la tabla un recorte de los datos aplanados */}
            <TablaComponente data={currentItems} />

            <Paginacion
                currentPage={currentPage}
                totalPages={totalPages}
                setCurrentPage={setCurrentPage}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
                totalItems={totalItems}
            />
        </div>
    );
};

export default TablaTramitacionExternaContainer;